import React from 'react';
import { useTranslation } from "react-i18next";
import Button from "../../storybook/Button";
import Modal from 'react-modal';
import Clear from "../../assets/img/Clear.png";
import { useAutoLogout } from './useAutoLogout';

if (process.env.NODE_ENV !== 'test') Modal.setAppElement("#root");

function twoDigits(num: number) {
    return String(num).padStart(2, '0');
}

export default function AutoLogout() {
    const { t } = useTranslation();
    const {
        modalIsOpen,
        showSignoutMessage,
        countdown,
        onContinue,
        onRedirectLoginPage,
        onShowSignoutMessage,
    } = useAutoLogout();

    return (
        <>
            <Modal isOpen={modalIsOpen} id="Modal-div" className="modalPopUp">
                <div id="timermodal-div">
                    <div className="text-end pb-16"><img src={Clear} alt="Cancel" onKeyDown={onContinue} onClick={onContinue} className="cursor-pointer" /></div>
                    <h1 id="backmodal-div3">{t("AutoLogoutMessage")}</h1>
                    <p className='pt-24'>{t("AutoLogoutText")}</p>
                    <p className='pt-16 pb-16'>
                        <span className='fw-bold pe-1'>{twoDigits(Math.floor(countdown / 60))}:{twoDigits(countdown % 60)}</span> {t("EMID024")}
                    </p>
                    <div id="backmodal-div3" className="modalPopup-footerbtn">
                        <div className="col-md-12 marginTop-auto">
                            <div className="row m-0 autolog-modal">
                                <div className="col-md-3 btn-top bordertop-none">
                                    <Button id="backmodal-btn2" onClick={onRedirectLoginPage} className="secondary-ghost-btn">
                                        {t("logout_button")}
                                    </Button>
                                </div>
                                <div className="col-md-9 text-end bordertop-none">
                                    <Button id="backmodal-btn1" className="primary-btn btn-padding" onClick={onContinue}>
                                        {t("Stay_logged_in")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal isOpen={showSignoutMessage} id="Modal-div" className="modalPopUp">
                <div id="timermodal-div">
                    <div className="text-end pb-16"><img src={Clear} alt="Cancel" onKeyDown={onShowSignoutMessage} onClick={onShowSignoutMessage} className="cursor-pointer" /></div>
                    <h1 id="backmodal-div3">{t("EMID025")}</h1>
                    <div id="backmodal-div3" className="modalPopup-footerbtn">
                        <div className="col-md-12 marginTop-auto">
                            <div className="row m-0 autolog-modal">
                                <div className="col-lg-12 text-end bordertop-none">
                                    <Button id="backmodal-btn2" className="secondary-ghost-btn mt-3" onClick={onShowSignoutMessage}>
                                        {t("ok_button")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}